"use client"

import { createContext, useContext, useState, type ReactNode } from "react"

export type CardDensity = `minimal` | `compact` | `detailed`

type ExpandContextValue = {
  density: CardDensity
  setDensity: (density: CardDensity) => void
}

const ExpandContext = createContext<ExpandContextValue | undefined>(undefined)

export function ExpandProvider({ children, initialDensity = `compact` }: { children: ReactNode; initialDensity?: CardDensity }) {
  const [density, setDensity] = useState<CardDensity>(initialDensity)

  return (
    <ExpandContext.Provider value={{ density, setDensity }}>
      {children}
    </ExpandContext.Provider>
  )
}

export function useExpand() {
  const context = useContext(ExpandContext)
  if (context === undefined) {
    throw new Error(`useExpand must be used within ExpandProvider`)
  }
  return context
}
